var styles = {"input":"styles_input__1Ja6l mx-auto col-12 md-col-4 mt2 mb2","placement-modal":"styles_placement-modal__1M6zX","placementModal":"styles_placement-modal__1M6zX"};

export default styles;
//# sourceMappingURL=styles.css.js.map
